<template>
  <div id="exchange_balance" class="clearfix mg_bot50">
    <div class="max_width">
      <div class="datatable">
        <data-table :getData="getData" :limit="10" :column="3" class="scroll">
          <th colspan="2">{{ this.$t("funds.balances.curency") }}</th>
          <th>{{ this.$t("funds.balances.value") }}</th>
          <template slot="body" slot-scope="props">
            <template v-if="!props.item?.usdt_erc20">
              <tr>
                <td class="exchange-coin" rowspan="6">
                  {{ props.item.assetId }} ({{ props.item.network }})
                </td>
                <td>{{ $t("exchange.table.hot_wallet_address") }}</td>
                <td>{{ props.item.hotWalletAddress }}</td>
              </tr>
              <tr>
                <td>{{ $t("exchange.table.hot_wallet_balance") }}</td>
                <td>
                  {{ props.item.hotWalletBalance }}
                  <span class="exchange-coin">{{ props.item.assetId }}</span>
                </td>
              </tr>
              <tr>
                <td>{{ $t("exchange.table.cold_wallet_balance") }}</td>
                <td>
                  {{ props.item.amountCollectColdWallet }}
                  <span class="exchange-coin">{{ props.item.assetId }}</span>
                </td>
              </tr>
              <!-- <tr>
              <td >{{ $t('exchange.table.hot_wallet_collected_fee') }}</td>
              <td >{{  props.item.feeCollectHotWallet }} <span class="exchange-coin">{{convertTypeFee(props.item.token_type)}}</span></td>
            </tr>
            <tr>
              <td >{{ $t('exchange.table.cold_wallet_collected_fee') }}</td>
              <td >{{  props.item.feeCollectColdWallet }} <span class="exchange-coin">{{convertTypeFee(props.item.token_type)}}</span></td>
            </tr> -->
              <tr>
                <td>{{ $t("exchange.table.total_wallet_balance") }}</td>
                <td>
                  {{ props.item.totalBalance }}
                  <span class="exchange-coin">{{ props.item.assetId }}</span>
                </td>
              </tr>
              <tr>
                <td>{{ $t("exchange.table.total_user_balance") }}</td>
                <td>
                  {{ props.item.balances }}
                  <span class="exchange-coin">{{ props.item.assetId }}</span>
                </td>
              </tr>
              <tr>
                <td class="font-bold">{{ $t("exchange.table.profit") }}</td>
                <td class="font-bold">
                  {{ subTotal(props.item.totalBalance, props.item.balances) }}
                  <span class="exchange-coin">{{ props.item.assetId }}</span>
                </td>
              </tr>
            </template>

            <!-- USDT -->
            <template v-else>
              <tr>
                <td class="exchange-coin" rowspan="10">
                  {{ props.item.assetId }} ({{ props.item.network }})
                </td>
                <td>
                  {{ $t("exchange.table.hot_wallet_address") }} on Ethereum
                </td>
                <td>{{ props.item.usdt_erc20.hotWalletAddress }}</td>
              </tr>
              <tr>
                <td>
                  {{ $t("exchange.table.hot_wallet_balance") }} on Ethereum
                </td>
                <td>
                  {{ props.item.usdt_erc20.hotWalletBalance }}
                  <span class="exchange-coin">{{ props.item.assetId }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  {{ $t("exchange.table.cold_wallet_balance") }} on Ethereum
                </td>
                <td>
                  {{ props.item.usdt_erc20.amountCollectColdWallet }}
                  <span class="exchange-coin">{{ props.item.assetId }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  {{ $t("exchange.table.total_wallet_balance") }} on Ethereum
                </td>
                <td>
                  {{ props.item.usdt_erc20.totalBalance }}
                  <span class="exchange-coin">{{ props.item.assetId }}</span>
                </td>
              </tr>

              <tr v-if="props.item.usdt_trc20">
                <td>{{ $t("exchange.table.hot_wallet_address") }} on Tron</td>
                <td>{{ props.item.usdt_trc20.hotWalletAddress }}</td>
              </tr>
              <tr v-if="props.item.usdt_trc20">
                <td>{{ $t("exchange.table.hot_wallet_balance") }} on Tron</td>
                <td>
                  {{ props.item.usdt_trc20.hotWalletBalance }}
                  <span class="exchange-coin">{{ props.item.assetId }}</span>
                </td>
              </tr>
              <tr v-if="props.item.usdt_trc20">
                <td>{{ $t("exchange.table.cold_wallet_balance") }} on Tron</td>
                <td>
                  {{ props.item.usdt_trc20.amountCollectColdWallet }}
                  <span class="exchange-coin">{{ props.item.assetId }}</span>
                </td>
              </tr>
              <tr v-if="props.item.usdt_trc20">
                <td>{{ $t("exchange.table.total_wallet_balance") }} on Tron</td>
                <td>
                  {{ props.item.usdt_trc20.totalBalance }}
                  <span class="exchange-coin">{{ props.item.assetId }}</span>
                </td>
              </tr>
              <tr>
                <td>{{ $t("exchange.table.total_user_balance") }}</td>
                <td>
                  {{ props.item.balances }}
                  <span class="exchange-coin">{{ props.item.assetId }}</span>
                </td>
              </tr>
              <tr>
                <td class="font-bold">{{ $t("exchange.table.profit") }}</td>
                <td class="font-bold">
                  {{ subTotal(props.item.totalBalance, props.item.balances) }}
                  <span class="exchange-coin">{{ props.item.assetId }}</span>
                </td>
              </tr>
            </template>
          </template>
        </data-table>
      </div>
    </div>
    <loading-modal />
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
import rf from "../../lib/RequestFactory";
import LoadingModal from "@/modals/common/LoadingModal.vue";

export default {
  components: {
    LoadingModal,
  },
  data() {
    return {
      titlePage: this.$t("exchange_balance.exchange_balance"),
    };
  },

  methods: {
    convertTypeFee(type) {
      if (!type) {
        return "USD";
      } else if (type === "polygon") {
        return "MATIC";
      } else if (type.includes("token")) {
        const index = type.indexOf("_");
        return type.slice(0, index);
      } else if (type === "tron") {
        return "TRX";
      } else {
        return type.toUpperCase();
      }
    },
    getDataBuyPath(props, path) {
      return window._.get(props, path, 0);
    },
    async getData(params) {
      this.$modal.show("modal-loading");
      try {
        const res = await rf
          .getRequest("CoinSettingRequest")
          .getWalletBalances(params);

        // Transform API response to match table format
        if (res) {
          const transformedData = {};

          res.forEach((item) => {
            // Use assetId/network as key to handle multiple networks for the same asset
            const key = `${item.assetId}/${item.network}`;
            transformedData[key] = {
              assetId: item.assetId,
              network: item.network,
              hotWalletAddress: item.hotWalletAddress,
              hotWalletBalance: item.hotWalletBalance,
              amountCollectColdWallet: item.coldWalletBalance,
              totalBalance: item.totalWalletBalance,
              balances: item.totalUserBalance,
            };
          });

          return {
            data: transformedData,
          };
        } else {
          return {
            data: [],
          };
        }
      } catch (error) {
        if (!error.response) {
          this.$toastr("error", this.$t("common.message.network_error"));
        }
        return {
          data: [],
        };
      } finally {
        this.$modal.hide("modal-loading");
      }
    },
    subTotal(totalBalance, balance) {
      return new BigNumber(totalBalance || 0).sub(balance || 0).toString();
    },
  },

  mounted() {
    this.$emit("EVENT_PAGE_CHANGE", this);
    this.getData();
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/variables";

#exchange_balance {
  margin-top: 10px;
  .font-bold {
    font-weight: bold;
    background: $color_catskill_white;
  }
  .max_width {
    display: block;
    // width: 700px;
    max-width: 100%;
  }

  .exchange-coin {
    width: 7%;
    /* text-transform: uppercase; */
  }

  th {
    font-family: $mulish-regular;
    font-size: $font-small;
    padding: 5px 25px 4px 15px !important;
  }

  th:nth-child(2) {
    border-left: 1px solid $color_alto;
  }

  td {
    font-family: $mulish-regular;
    white-space: nowrap;
  }
  tr td:first-child {
    border-right: 1px solid $color_alto;
    border-bottom: 1px solid $color_alto;
  }
  tr td:nth-child(2) {
    border-top: 1px solid $color_alto;
    border-bottom: 1px solid $color_alto;
    border-left: 1px solid $color_alto;
  }
  tr td:last-child {
    border-left: 1px solid $color_alto;
    border-bottom: 1px solid $color_alto;
  }

  .text-right::after {
    display: none;
  }
}
</style>
